import { render, staticRenderFns } from "./StepColumnMappingV2.vue?vue&type=template&id=e4dcdaca&scoped=true"
import script from "./StepColumnMappingV2.vue?vue&type=script&lang=js"
export * from "./StepColumnMappingV2.vue?vue&type=script&lang=js"
import style0 from "./StepColumnMappingV2.vue?vue&type=style&index=0&id=e4dcdaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dcdaca",
  null
  
)

export default component.exports